import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-maintenance',
    templateUrl: './maintenance.component.html',
    styleUrls: ['./maintenance.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class MaintenanceComponent implements OnInit {

  public phoneNumber = '';
  public maintenanceText = {};

  constructor(
    private translateService: TranslateService
  ) { }

  ngOnInit(): void {
    this.translateService.get("maintenance.texts").subscribe(texts => {
      this.maintenanceText = texts;
      this.phoneNumber = this.translateService.instant("maintenance.phoneNumber");
    });

  }
}
